<fnx-loading *ngIf="loading"></fnx-loading>
<iframe
  class="iframe-webapp test-webapp-iframe"
  [class.iframe-webapp--hidden]="loading"
  allowfullscreen
  #iframe
  (load)="onLoad($event)"
></iframe>
